import { Ability } from 'providers/casl'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql, permitFields } from 'providers/tanstack-query/utils'
import { AdUnitAmazonSliceDTO } from './types'

export const GET_AD_UNIT_AMAZON_FRAGMENT = (
  ability: Ability,
): TypedDocumentNode<AdUnitAmazonSliceDTO> => gql`
  fragment AdUnitAmazonFragment on AdUnitAmazon {
    adUnit {
      ${permitFields<AdUnitAmazonSliceDTO['adUnit']>({
        ybAdUnitEnabled: ability.can('read', 'AdUnitField-ybAdUnitEnabled'),
      })}
      divId
      id
      path
    }
    enabled
    id
    updatedAt
  }
`
